import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { useFormContext } from "react-hook-form";

export const useValidateSeoRequiere = () => {
  const { trigger } = useFormContext();
  const validate = async () => {
    return trigger([
      CPropertyFormKeys.city_property,
      CPropertyFormKeys.sector_property,
      CPropertyFormKeys.meter_construction_property,
      CPropertyFormKeys.meter_land_property
    ]);
  };
  return { validate };
};
